/**
 * App-wide exclusive **dropdown** slot — at most one `DropdownMenu exclusive` open.
 * Independent of ContentTooltip exclusivity (separate tip singleton).
 * Claim B dismisses A (subscribers close).
 */

type Listener = () => void;

let activeId: string | null = null;
const listeners = new Set<Listener>();

function emit(): void {
	for (const listener of listeners) {
		listener();
	}
}

export function getExclusiveOverlayActiveId(): string | null {
	return activeId;
}

export function subscribeExclusiveOverlay(listener: Listener): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

/** Claim exclusive dropdown ownership. Previous menu is cleared (subscribers close). */
export function claimExclusiveOverlay(id: string): void {
	if (activeId === id) {
		return;
	}
	activeId = id;
	emit();
}

/** Release if this id still owns the dropdown slot. */
export function releaseExclusiveOverlay(id: string): void {
	if (activeId !== id) {
		return;
	}
	activeId = null;
	emit();
}

/** Force-clear exclusive dropdown slot. Does not dismiss ContentTooltips. */
export function clearExclusiveOverlay(): void {
	if (activeId == null) {
		return;
	}
	activeId = null;
	emit();
}

/** Test helper — reset singleton between vitest cases. */
export function resetExclusiveOverlayStoreForTests(): void {
	activeId = null;
	listeners.clear();
}
